/**
 * nav item icon size
 */
export const navItemIconSize = { height: "16", width: "16" }

export const activeStyles = {
  prominent: "prominent",
  highlight: "highlight",
}

/**
 * Default NavItem active style.
 */
export const DEFAULT_ACTIVE_STYLE = activeStyles.prominent
